import { createSlice } from "@reduxjs/toolkit";

export interface IBreadCrumbItem {
  label: string;
  routeTo: string;
}
const initialState: { breadCrumbItems: IBreadCrumbItem[] } = {
  breadCrumbItems: [],
};

const breadCrumbSlice = createSlice({
  name: "breadCrumb",
  initialState,
  reducers: {
    setBreadCrumbItems: (state, action) => {
      state.breadCrumbItems = [...action.payload];
    },
  },
});
export const { setBreadCrumbItems } = breadCrumbSlice.actions;

export default breadCrumbSlice.reducer;
